import RedButton from 'components/buttons/RedButton';

type LocationSubmitButtonProps = {
  onClick: () => void;
  disabled: boolean;
  label: string;
};

export const LocationSubmitButton = ({ onClick, disabled, label }: LocationSubmitButtonProps) => (
  <RedButton data-testid='location-button' onClick={onClick} disabled={disabled}>
    {label}
  </RedButton>
);
